
import Vue from 'vue'
import Router from 'vue-router'

// import goodsList from '@/pages/goodsList'
Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: {title: '润启招标'}
    },
    {
      path: '/home',
      component: () => import('../pages/home.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/about',
      component: () => import('../pages/about.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/bussiness',
      component: () => import('../pages/bussiness.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/bidding',
      component: () => import('../pages/bidding.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/biddingDetail',
      component: () => import('../pages/biddingDetail.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/succbid',
      component: () => import('../pages/succbid.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/supplement',
      component: () => import('../pages/supplement.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/news',
      component: () => import('../pages/news.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/newsDetail',
      component: () => import('../pages/newsDetail.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/policies',
      component: () => import('../pages/policies.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/policiesDetail',
      component: () => import('../pages/policiesDetail.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/contact',
      component: () => import('../pages/contact.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/message',
      component: () => import('../pages/message.vue'),
      meta: { title: '润启招标' },
    },
    {
      path: '/join',
      component: () => import('../pages/join.vue'),
      meta: { title: '润启招标' },
    },
  ]
})

// router.beforeEach((to, from, next) => {
//   if ((to.path === '/login') || (to.path === '/register') || (to.path === '/register/password') ||
//     (to.path === '/register/finsh') || (to.path === '/register/forgetPass') ||
//     (to.path === '/register/applyEnterRegister') || (to.path === '/register/successFinish')) {
//     next()
//   } else {
//     console.log('userCode=', cookie.get('SysGph'))
//     if ((typeof (cookie.get('SysGph')) === 'undefined') || (cookie.get('SysGph') === '')) { // cookie中userCode为空，不是退出就是未登录或登录超时
//       next({ path: '/login' })
//     } else if (typeof (to.meta.requiresAuth) === 'undefined' && !JSON.parse(cookie.get('SysGph')).token) {
//       next({ path: '/login' })
//     } else {
//       next()
//     }
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js